import matches from '../src/matches';
import closest from '../src/closest';

export default closest(matches());
